import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("titles.sanbdox_requests"))),
      ]),
      _vm._t("default"),
      _c("actions-component", {
        attrs: { class_table: _vm.getClass },
        scopedSlots: _vm._u([
          {
            key: "description",
            fn: function () {
              return [
                _c(VBreadcrumbs, {
                  staticClass: "pa-0",
                  attrs: { items: _vm.getBreadcrumbs },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c(
                  VBtn,
                  {
                    staticClass: "btn-inca-secondary",
                    attrs: { icon: "" },
                    on: { click: _vm.refreshClick },
                  },
                  [_c(VIcon, [_vm._v("mdi-refresh")])],
                  1
                ),
                _vm.activeTab === 0
                  ? _c(
                      VBtn,
                      {
                        staticClass: "ml-1 btn-inca-secondary",
                        attrs: { dense: "", outlined: "" },
                        on: { click: _vm.onEnableFilter },
                      },
                      [
                        _vm.filterEnabled
                          ? _c(VIcon, { attrs: { small: "" } }, [
                              _vm._v("mdi-filter-off-outline"),
                            ])
                          : _vm._e(),
                        !_vm.filterEnabled
                          ? _c(VIcon, { attrs: { small: "" } }, [
                              _vm._v("mdi-filter-outline"),
                            ])
                          : _vm._e(),
                        _vm._v(
                          " " + _vm._s(_vm.$t("botones.boton_filtrar")) + " "
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        VTabs,
        {
          staticClass: "mt-2",
          attrs: { "background-color": "transparent", color: "primary" },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(VTab, [
            _vm._v(_vm._s(_vm.$t("ownership_requests.tabs.sandbox"))),
          ]),
          _c(VTab, [
            _vm._v(_vm._s(_vm.$t("ownership_requests.tabs.create_attribute"))),
          ]),
        ],
        1
      ),
      _c(
        VTabsItems,
        {
          staticClass: "transparent",
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            VTabItem,
            [
              _c(VRow, [
                _c(
                  "div",
                  { class: _vm.getClass },
                  [
                    _c(
                      VCard,
                      [
                        _c(VDataTable, {
                          staticClass: "text-center table-inca",
                          attrs: {
                            responsive: "",
                            hover: "",
                            items: _vm.items,
                            headers: _vm.headers,
                            search: _vm.search,
                            "hide-default-footer": "",
                            "items-per-page": _vm.pagination.limit,
                            page: _vm.pagination.current,
                          },
                          on: {
                            pagination: function ($event) {
                              _vm.pagination.total = $event.itemsLength
                            },
                            "update:page": function ($event) {
                              return _vm.$set(_vm.pagination, "current", $event)
                            },
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "item.attribute_count",
                              fn: function (ref) {
                                var item = ref.item
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        item.attribute_count -
                                          (item.last_attribute_count || 0)
                                      )
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "item.creation_date",
                              fn: function (ref) {
                                var item = ref.item
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm
                                          .$moment(new Date(item.creation_date))
                                          .format("DD/MM/YYYY")
                                      )
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "item.actions",
                              fn: function (ref) {
                                var item = ref.item
                                return [
                                  item.flag_attribute_alert === "1"
                                    ? _c(
                                        VTooltip,
                                        {
                                          attrs: { top: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function (ref) {
                                                  var on = ref.on
                                                  var attrs = ref.attrs
                                                  return [
                                                    _c(
                                                      VBtn,
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            attrs: {
                                                              outlined: "",
                                                              color: "primary",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.onOpenModalUseCase(
                                                                  item,
                                                                  _vm.DIALOG_SEE_SANDBOX_REQUEST
                                                                )
                                                              },
                                                            },
                                                          },
                                                          "v-btn",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      ),
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "frases.view_request"
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                        _c(
                                                          VIcon,
                                                          {
                                                            staticStyle: {
                                                              "margin-left":
                                                                "2px",
                                                            },
                                                            attrs: {
                                                              small: "",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "mdi-alert-circle-outline"
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(_vm._s(item.response)),
                                          ]),
                                        ]
                                      )
                                    : _c(
                                        VBtn,
                                        {
                                          attrs: {
                                            outlined: "",
                                            color: "primary",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onOpenModalUseCase(
                                                item,
                                                _vm.DIALOG_SEE_SANDBOX_REQUEST
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("frases.view_request")
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("pagination-vue", {
                          attrs: { pagination: _vm.pagination },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.filterEnabled
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "order-md-last order-first col-md-3 col-12 pl-md-0 mb-2",
                      },
                      [
                        _c(
                          VCard,
                          [
                            _c(VCardTitle, { staticClass: "pointer" }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("titles.search_filters")) +
                                  " "
                              ),
                            ]),
                            _c(
                              VCardText,
                              { staticClass: "pa-2 pt-0" },
                              [
                                _c(
                                  VRow,
                                  { attrs: { dense: "" } },
                                  [
                                    _c(
                                      VCol,
                                      { attrs: { cols: "12" } },
                                      [
                                        _c(VTextField, {
                                          attrs: {
                                            label: _vm.$t(
                                              "attributes.label.use_case_name"
                                            ),
                                            placeholder: _vm.$t(
                                              "attributes.placeholder.use_case"
                                            ),
                                            type: "text",
                                            outlined: "",
                                            dense: "",
                                          },
                                          on: {
                                            keyup: function ($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              return _vm.onSearch($event)
                                            },
                                          },
                                          model: {
                                            value: _vm.filters.text_filter,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.filters,
                                                "text_filter",
                                                $$v
                                              )
                                            },
                                            expression: "filters.text_filter",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      VCol,
                                      {
                                        staticClass: "text-right",
                                        attrs: { cols: "12" },
                                      },
                                      [
                                        _c(
                                          VBtn,
                                          {
                                            staticClass: "default mr-1",
                                            attrs: { outlined: "" },
                                            on: { click: _vm.onCleanSearch },
                                          },
                                          [_vm._v(_vm._s(_vm.$t("btns.clean")))]
                                        ),
                                        _c(
                                          VBtn,
                                          {
                                            staticClass: "primary",
                                            on: { click: _vm.onSearch },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("btns.search"))
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      VCol,
                                      {
                                        staticClass: "text-right",
                                        attrs: { cols: "12 mt-3" },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "attributes.label.total_records"
                                              )
                                            ) +
                                            ": " +
                                            _vm._s(_vm.totalRecords) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _c("dialogs-component", {
                ref: _vm.DIALOG_SEE_SANDBOX_REQUEST,
                attrs: {
                  title: _vm.dialogTitle,
                  "show-buttons": true,
                  width: 900,
                },
                scopedSlots: _vm._u([
                  {
                    key: "body",
                    fn: function () {
                      return [
                        _c("sandbox-request-detail-component", {
                          ref: "sanbdoxRequestComponent",
                          attrs: { item: _vm.useCase },
                          on: {
                            close: function ($event) {
                              return _vm.onCloseModal(
                                _vm.DIALOG_SEE_SANDBOX_REQUEST
                              )
                            },
                            approve: function ($event) {
                              _vm.loading.approve = true
                            },
                            reject: function ($event) {
                              _vm.loading.reject = true
                            },
                            click: function ($event) {
                              _vm.loading.approve = true
                            },
                            onChangePercentage: _vm.onChangePercentage,
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "btnsRight",
                    fn: function () {
                      return [
                        _c(
                          VBtn,
                          {
                            attrs: {
                              color: "secondary",
                              loading: _vm.loading.reject,
                              disabled: _vm.loading.approve,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.$refs.sanbdoxRequestComponent.onReject(
                                  $event
                                )
                              },
                            },
                          },
                          [
                            _c(VIcon, { attrs: { left: "" } }, [
                              _vm._v("mdi-cancel"),
                            ]),
                            _vm._v(" Reject "),
                          ],
                          1
                        ),
                        _c(
                          VBtn,
                          {
                            staticStyle: { padding: "0px" },
                            attrs: {
                              type: "button",
                              width: "120px",
                              color: _vm.btnColor(),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.$refs.sanbdoxRequestComponent.onSubmit(
                                  $event
                                )
                              },
                            },
                          },
                          [
                            _vm.loading.approve
                              ? _c(
                                  VProgressLinear,
                                  {
                                    attrs: {
                                      dark: "",
                                      "background-opacity": "0.8",
                                      height: "36px",
                                      rounded: "",
                                    },
                                    model: {
                                      value: _vm.value,
                                      callback: function ($$v) {
                                        _vm.value = $$v
                                      },
                                      expression: "value",
                                    },
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(Math.ceil(_vm.value)) + "%"
                                      ),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                            !_vm.loading.approve
                              ? _c(VIcon, { attrs: { left: "" } }, [
                                  _vm._v("mdi-check"),
                                ])
                              : _vm._e(),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.loading.approve ? "" : _vm.texto_finalizar
                                ) +
                                " "
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            VTabItem,
            [
              _c(VRow, { staticClass: "mt-2" }, [
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c(
                      VCard,
                      [
                        _c(VDataTable, {
                          staticClass: "text-center table-inca",
                          attrs: {
                            responsive: "",
                            hover: "",
                            loading: _vm.createAttrLoading,
                            items: _vm.createAttrItems,
                            headers: _vm.createAttrHeaders,
                            "hide-default-footer": "",
                            "items-per-page": _vm.createAttrPagination.limit,
                            page: _vm.createAttrPagination.current,
                          },
                          on: {
                            pagination: function ($event) {
                              _vm.createAttrPagination.total =
                                $event.itemsLength
                            },
                            "update:page": function ($event) {
                              return _vm.$set(
                                _vm.createAttrPagination,
                                "current",
                                $event
                              )
                            },
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "item.fecha_creacion",
                              fn: function (ref) {
                                var item = ref.item
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatCreateAttrDate(
                                          item.fecha_creacion
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "item.total_periods",
                              fn: function (ref) {
                                var item = ref.item
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.periodCount(item))),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "item.actions",
                              fn: function (ref) {
                                var item = ref.item
                                return [
                                  _c(
                                    VBtn,
                                    {
                                      attrs: { outlined: "", color: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openPartitionReview(item)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "ownership_requests.create_attribute.review"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("pagination-vue", {
                          attrs: { pagination: _vm.createAttrPagination },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("partition-review-dialog", {
        ref: "partitionReviewDialog",
        on: { approved: _vm.onCreateAttrApproved },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }